    <div style="height: 100%" class="card">
  <!-- Card Header -->
  <div class="px-4 py-3 border-b">
    <h3 class="text-lg font-semibold">CRD Branch</h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <kendo-grid
      [kendoGridBinding]="repState.crdBranches"
      [pageSize]="20"
      [pageable]="true"
      filterable="true"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <button
          type="button"
          icon="plus-outline"
          look="flat"
          kendoGridAddCommand
        >
          Add New Record
        </button>
        <label class="k-checkbox-label" for="toggleViewActive"
          >Show Active Only</label
        >
        <input
          [(ngModel)]="checked"
          [indeterminate]="false"
          type="checkbox"
          (click)="toggleViewActive(checked)"
          id="toggleViewActive"
          kendoCheckBox
        />
        <button
          type="button"
          icon="refresh-sm"
          (click)="toggleViewRefresh()"
          look="flat"
          kendoButton
          class="display-end"
        >
          Refresh
        </button>
      </ng-template>
      <kendo-grid-column
        field="crdBranchNumber"
        title="CRD Branch #"
        width="110"
      >
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="crdBranchName" title="Branch Name" width="110">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
     <!--  <kendo-grid-column field="crdBranchTypeName" title="Type" width="85">
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="k-adjust-width"
            [data]="activeCrdBranchTypes"
            textField="crdBranchDescription"
            valueField="crdBranchTypeID"
            valuePrimitive="true"
            [formControl]="formGroup.get('crdBranchTypeID')"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column> -->
      <kendo-grid-column
        field="officeDBAName"
        title="Office DBA"
        width="140"
        [filterable]="false"
      >
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="startDate"
        title="Start Date"
        width="80"
        [filterable]="false"
      >
        <ng-template kendoGridCellTemplate let-column>
          {{ column.startDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-datepicker
            class="k-adjust-width"
            type="date"
            [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy"
            [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "
          ></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="endDate"
        title="End Date"
        width="80"
        [filterable]="false"
      >
        <ng-template kendoGridCellTemplate let-column>
          {{ column.endDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-datepicker
            class="k-adjust-width"
            type="date"
            [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy"
            [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "
          ></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="personInCharge"
        title="Person In Charge"
        width="115"
        [filterable]="false"
      >
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="designatedSupervisor"
        title="Supervisor"
        width="100"
      >
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
     <!--  <kendo-grid-column
        field="privateRes"
        title="Private Residence"
        width="75"
        [headerStyle]="{ height: 'auto', 'white-space': 'normal' }"
        [filterable]="false"
      >
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.privateRes" disabled />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="sharedOffice"
        title="Shared Office"
        width="60"
        [headerStyle]="{ height: 'auto', 'white-space': 'normal' }"
        [filterable]="false"
      >
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.sharedOffice" disabled />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="brokerFirmName"
        title="Broker Firm Type"
        width="110"
        [filterable]="false"
      >
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="k-adjust-width"
            [data]="activeBrokerFirms"
            textField="brokerFirmType"
            valueField="brokerFirmID"
            valuePrimitive="true"
            [formControl]="formGroup.get('brokerFirmID')"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="bankName"
        title="Bank"
        width="100"
        [filterable]="false"
      >
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="k-adjust-width"
            [data]="activeBanks"
            textField="bankName"
            valueField="bankCode"
            valuePrimitive="true"
            [formControl]="formGroup.get('bankID')"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="branchDescription"
        title="Branch Code"
        width="90"
        [filterable]="false"
      >
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="k-adjust-width"
            [data]="activeBranches"
            textField="branchDescription"
            valueField="branchCode"
            valuePrimitive="true"
            [formControl]="formGroup.get('branchCode')"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="officeTypeName"
        title="Office Type"
        width="80"
        [filterable]="false"
      >
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="k-adjust-width"
            [data]="activeOfficeTypes"
            textField="officeTypeDescription"
            valueField="officeTypeID"
            valuePrimitive="true"
            [formControl]="formGroup.get('officeTypeID')"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="officeRegionName"
        title="Office Region"
        width="100"
        [filterable]="false"
      >
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="k-adjust-width"
            [data]="activeRegions"
            textField="regionName"
            valueField="regionId"
            valuePrimitive="true"
            [formControl]="formGroup.get('officeRegion')"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column> -->

      <kendo-grid-command-column title="Command" width="120">
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
        >
          <button kendoGridEditCommand [primary]="true">Edit</button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
            Save
          </button>
          <button kendoGridCancelCommand>Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
</div></div>
